export default `
<span class="course-track-quiz-question-choice">
  <input class="course-track-quiz-question-choice-radio-button" type="radio" name="question_{{$ctrl.questionId}}" id="choice_{{$ctrl.choice.id}}" value="{{$ctrl.choice.id}}" ng-model="$ctrl.userChoice[$ctrl.questionNumber].answer"/>
  <label class="course-track-quiz-question-choice-option" for="choice_{{$ctrl.choice.id}}" >
    <span class="course-track-quiz-question-choice__letter" ng-bind="['A.', 'B.', 'C.', 'D.'][$ctrl.choiceIndex]"></span>
    {{$ctrl.choice.answer}}
  </label>
</span>
`;
